<template>
  <div class='Box'>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">
        <span>配置项管理</span>
      </div>
      <el-form label-width="100px">
        <el-form-item label="服务内容">
          <RichEditor v-model="content" placeholder="请输入服务内容" />
        </el-form-item>
        <el-form-item label="小程序网址">
          <el-input v-model="miniAppUrl" placeholder="请输入小程序网址" clearable style="width: 500px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="save">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { rcApis } from "@/api/rc";
import { processErrors } from "@/utils/errorHandler";
import RichEditor from "@/components/RichEditor";
const api = rcApis();
export default {
  components: { RichEditor },
  data() {
    return {
      content: "",
      miniAppUrl: "",
      loading: false,
      saving: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.loading = true;
      api.ServiceConfigInfo().then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.content = (res.data && res.data.content) ? res.data.content : "";
          this.miniAppUrl = (res.data && res.data.mini_app_url) ? res.data.mini_app_url : "";
        } else {
          processErrors(res);
        }
      });
    },
    save() {
      this.saving = true;
      api.ServiceConfigSave({
        content: this.content,
        mini_app_url: this.miniAppUrl
      }).then(res => {
        this.saving = false;
        if (res.code == 0) {
          this.$message.success('保存成功');
        } else {
          processErrors(res);
        }
      });
    },
  },
}
</script>
<style lang='scss' scoped>
</style>
